import {
  Box,
  Grid,
  Typography,
} from "@mui/material";
import React, { useEffect } from "react";
import { Controller, useForm } from "react-hook-form";
import TextInput from "./forms/TextInput/TextInput";

type MailingAddressFormValues = {
  addressLine1?: string;
  addressLine2?: string;
  city?: string;
  state?: string;
  zip?: string;
};

type MailingAddressFormProps = {
  addressLine1?: string;
  addressLine2?: string;
  city?: string;
  state?: string;
  zip?: string;
  memberId?: string;
  readOnly?: boolean;
  initialLoading?: boolean;
  onUpdateSuccess?: () => void;
};

const MailingAddressForm: React.FC<MailingAddressFormProps> = (props) => {
  const { control, handleSubmit, reset } = useForm<MailingAddressFormValues>({
    defaultValues: {
      addressLine1: props.addressLine1 ?? "",
      addressLine2: props.addressLine2 ?? "",
      city: props.city ?? "",
      state: props.state ?? "",
      zip: props.zip ?? "",
    },
  });

  useEffect(() => {
    reset({
      addressLine1: props.addressLine1 ?? "",
      addressLine2: props.addressLine2 ?? "",
      city: props.city ?? "",
      state: props.state ?? "",
      zip: props.zip ?? "",
    });
  }, [
    props.addressLine1,
    props.addressLine2,
    props.city,
    props.state,
    props.zip,
  ]);

  const disabled = props.readOnly;

  return (
    <Box mb={4}>
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          gap: 1,
          mb: 2,
        }}
      >
        <Typography variant="h4">Mailing Address</Typography>
      </Box>
      <Grid
        container
        spacing={2}
        columns={{
          xs: 1,
          sm: 3,
          md: 5,
        }}
      >
        <Grid size={1}>
          <Controller
            name="addressLine1"
            control={control}
            rules={{
              required: "Address is required",
            }}
            render={({ field, fieldState: { error } }) => (
              <TextInput
                {...field}
                label="Address 1"
                fullWidth
                disabled={disabled}
                initialLoading={props.initialLoading}
                error={!!error?.message}
                helperText={error?.message || ""}
              />
            )}
          />
        </Grid>
        <Grid size={1}>
          <Controller
            name="addressLine2"
            control={control}
            render={({ field, fieldState: { error } }) => (
              <TextInput
                {...field}
                label="Address 2"
                fullWidth
                disabled={disabled}
                initialLoading={props.initialLoading}
                error={!!error?.message}
                helperText={error?.message || ""}
              />
            )}
          />
        </Grid>
        <Grid size={1}>
          <Controller
            name="city"
            rules={{
              required: "City is required",
            }}
            control={control}
            render={({ field, fieldState: { error } }) => (
              <TextInput
                {...field}
                label="City"
                fullWidth
                disabled={disabled}
                initialLoading={props.initialLoading}
                error={!!error?.message}
                helperText={error?.message || ""}
              />
            )}
          />
        </Grid>
        <Grid size={1}>
          <Controller
            name="state"
            rules={{
              required: "State is required",
            }}
            control={control}
            render={({ field, fieldState: { error } }) => (
              <TextInput
                {...field}
                label="State"
                fullWidth
                disabled={disabled}
                initialLoading={props.initialLoading}
                error={!!error?.message}
                helperText={error?.message || ""}
              />
            )}
          />
        </Grid>
        <Grid size={1}>
          <Controller
            name="zip"
            control={control}
            rules={{
              required: "Zip code is required",
            }}
            render={({ field, fieldState: { error } }) => (
              <TextInput
                {...field}
                label="Zip Code"
                fullWidth
                disabled={disabled}
                initialLoading={props.initialLoading}
                error={!!error?.message}
                helperText={error?.message || ""}
              />
            )}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default MailingAddressForm;
